(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class PasswordVideo extends HTMLElement {
    connectedCallback() {
      this.viewport = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.video = this.querySelector('video');
      this.button = this.closest('.cs-password-campaign').querySelector('.cs-password-video-toggle');
      this.refresh = () => { this.video.load(); if (this.motion.matches) this.video.pause(); };
      this.toggle = () => { if (this.video.paused) this.video.play().catch(() => {}); else this.video.pause(); };
      this.update = () => { this.button.textContent = this.video.paused ? this.button.dataset.play : this.button.dataset.pause; };
      this.viewport.addEventListener('change', this.refresh);
      this.motion.addEventListener('change', this.refresh);
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.update);
      this.video.addEventListener('pause', this.update);
      if (this.motion.matches) { this.video.autoplay = false; this.video.pause(); }
      this.update();
    }
    disconnectedCallback() {
      this.viewport.removeEventListener('change', this.refresh);
      this.motion.removeEventListener('change', this.refresh);
      this.button.removeEventListener('click', this.toggle);
      this.video.removeEventListener('play', this.update);
      this.video.removeEventListener('pause', this.update);
    }
  }
  if (!customElements.get('cs-password-video')) customElements.define('cs-password-video', PasswordVideo);

  } catch(e) { console.error(e); }
})();
})();
